import { useEffect } from 'react';
import { random } from 'lodash-unified';
import { webSocketsRepository, REFRESH_IFRAME, refreshIframe } from '@bg-shared';

export const useRefreshIframe = (): void => {
    useEffect(() => {
        webSocketsRepository.on(REFRESH_IFRAME, () => {
            setTimeout(
                () => {
                    refreshIframe();
                },
                random(1, 15) * 1000,
            );
        });
    }, []);
};
